<div class="dialog-shell">
  <header class="dialog-header">
    <div>
      <p class="eyebrow">Developer</p>
      <h1>{{data?.title || 'API Endpoints'}}</h1>
    </div>
    <div class="header-actions">
      <button mat-stroked-button color="primary" *ngIf="!isLoading && !error" (click)="copyVisibleEndpoints()">
        <mat-icon>content_copy</mat-icon> Copy JSON
      </button>
      <span class="copied" *ngIf="copied">Copied</span>
      <button mat-icon-button mat-dialog-close aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <mat-spinner *ngIf="isLoading"></mat-spinner>
  <div class="error" *ngIf="!isLoading && error">{{error}}</div>

  <div class="docs-layout" *ngIf="!isLoading && !error">
    <aside class="endpoint-list">
      <mat-form-field appearance="outline">
        <mat-label>Search endpoints</mat-label>
        <input matInput [(ngModel)]="query" (ngModelChange)="search()">
      </mat-form-field>

      <section class="endpoint-group" *ngFor="let group of filteredGroups">
        <h2>{{group.service}}</h2>
        <button
          type="button"
          class="endpoint-button"
          [class.active]="selectedEndpoint === endpoint"
          *ngFor="let endpoint of group.endpoints"
          (click)="selectEndpoint(endpoint)">
          <span class="method" [class]="endpoint.method.toLowerCase()">{{endpoint.method}}</span>
          <span class="path">{{endpoint.path}}</span>
        </button>
      </section>
    </aside>

    <main class="endpoint-detail" *ngIf="selectedEndpoint">
      <div class="endpoint-title">
        <span class="method" [class]="selectedEndpoint.method.toLowerCase()">{{selectedEndpoint.method}}</span>
        <h2>{{selectedEndpoint.path}}</h2>
      </div>

      <div class="meta-row">
        <span class="auth" [class.public]="selectedEndpoint.auth === 'public'">{{selectedEndpoint.auth}}</span>
        <span>{{selectedEndpoint.sourceFile}}</span>
      </div>

      <p class="summary" *ngIf="selectedEndpoint.summary">{{selectedEndpoint.summary}}</p>

      <section>
        <h3>cURL</h3>
        <pre><code>{{getCurl(selectedEndpoint)}}</code></pre>
      </section>

      <section *ngIf="selectedEndpoint.requestExample !== undefined">
        <h3>Request Body</h3>
        <pre><code>{{stringify(selectedEndpoint.requestExample)}}</code></pre>
      </section>

      <section *ngIf="selectedEndpoint.responseExample !== undefined">
        <h3>Response</h3>
        <pre><code>{{stringify(selectedEndpoint.responseExample)}}</code></pre>
      </section>
    </main>
  </div>
</div>
